import { css } from '@emotion/css'
import { spacing, borderRadius } from '../../../styles'
import { colors } from '../../../themes'

const styles = {
  header: css({
    backgroundColor: colors.geyser,
  }),

  row: css({
    '& > th:first-child': {
      borderTopLeftRadius: borderRadius.default,
    },

    '& > th:last-child': {
      borderTopRightRadius: borderRadius.default,
    },
  }),

  cell: css({
    padding: spacing.default,
    textAlign: 'left',
  }),
}

export default styles
